var TusdConfig = function TusdConfig() {
  var _props$path, _props$tusdUrl;

  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var headers = {};
  var metadata = {};

  if (props.signature) {
    headers.Authorization = props.signature;
  }

  if ((_props$path = props.path) !== null && _props$path !== void 0 && _props$path.length) {
    metadata.storepath = props.path;
  }

  if (!((_props$tusdUrl = props.tusdUrl) !== null && _props$tusdUrl !== void 0 && _props$tusdUrl.length)) {
    throw new Error('Missing required prop tusdUrl');
  }

  return {
    endpoint: props.tusdUrl,
    uploadUrl: props.tusdUrl,
    chunkSize: 5242880,
    // exactly 5mb in bytes. Aws S3 defaults to multi-part part sizes at this length
    removeFingerprintOnSuccess: true,
    headers: headers,
    metadata: metadata
  };
};

export default TusdConfig;